<template lang="html">
  <div
    class="product-mobile-buy-bar fixed inset-x-0 bottom-[calc(2.875rem+env(safe-area-inset-bottom,0px)-1px)] z-10 flex items-center gap-3 border-t border-default bg-default px-4 py-3 lg:hidden"
  >
    <PromoPrice
      :value="props.value"
      class="shrink-0 text-base"
    />

    <div
      v-if="!props.value.inStock"
      class="flex-1 text-center text-sm font-medium text-error"
    >
      Нет в наличии
    </div>

    <div
      v-else
      class="flex min-w-0 flex-1 flex-col"
    >
      <CartSection
        :value="props.value"
        class="w-full"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ProductDto } from '@repo/api/web/models'

import CartSection from '#Products/components/Detail/CartSection.vue'
import PromoPrice from '#Promotion/components/PromoPrice.vue'

const props = defineProps<{
  value: ProductDto
}>()
</script>
